import axios from 'axios'
import { errorHandler } from '../exports/error_management'


const api = async (method, path, params) => axios[method](path, params)

const state = {
    item: null,
    items: [],
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            const results = await api('post', `bill-payment-email-sender`, payload)
            const data = results.data.success.data
            context.commit('set_item', data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, id) {
        try {
            await context.dispatch('fetchAll')
            context.commit(
                'set_item',
                context.state.items.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchAll(context) {
        try {
            const results = await api('get', `bill-payment-email-sender`)
            let value = []
            console.log('results.data', results.data)
            const data = results.data.success.data
            value.splice(0)
            value.push(...data)
            
            context.commit('set_items', value)
        } catch (err) {
            errorHandler(err)
        }
    },
    async updateBillPaymentEmailSenderOrder(context, payload) {
        try {
             await api(
                'post',
                `bill-payment-email-sender/update/display/order/`,
                payload
            )
            context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `bill-payment-email-sender/${payload.id}`,
                payload
            )
            const data = results.data.success.data
            context.commit('set_item', data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, id) {
        try {
            await api('delete', `bill-payment-email-sender/${id}`)
            context.commit('set_item', null)
            
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
